<div class="modal-form">
  <div class="card form-modal" style="min-width: 400px">
    <div class="card-header">
      {{item.titulo}}
      <div class="close-button" (click)="close()">
        x
      </div>
    </div>
    <div class="card-body">
      <div class="form-group">
        <textarea class="form-control" id="textarea1" rows="3" [(ngModel)]="contenido"></textarea>
        <small id="emailHelp" class="form-text text-muted">64 caracteres como maximo.</small>
      </div>
      <button class="btn" (click)="close()" style="margin-right: 10px">Salir</button>
      <button [disabled]="contenido == contenido_validar" class="btn" (click)="success()"
              [ngClass]="{'btn-danger':contenido != contenido_validar}">{{item.success_btn_text}}
      </button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/modal-new-noticia/modal-new-noticia.component.html